import React from 'react'

export const TabTouch = () => (
  <svg width='95' height='19' viewBox='0 0 95 19' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M48.8706 9.79904H47.2794V15.3043C47.2794 15.9177 47.3424 16.0864 47.8623 16.0864H48.8234C49.0755 16.0864 49.2645 16.2551 49.2645 16.4697V18.3866C49.2645 18.6166 49.0755 18.7393 48.8234 18.8007C48.1302 18.9387 47.4842 18.9847 46.9486 18.9847C44.6957 18.9847 43.2305 18.3099 43.2305 15.2583V9.79904L41.8441 9.49234C41.6078 9.431 41.403 9.26232 41.403 9.04763V7.33011C41.403 7.10009 41.592 6.90073 41.8441 6.90073H43.2305V5.24456C43.2305 5.01453 43.4353 4.86118 43.6716 4.81518L46.8068 4.27845C47.1849 4.21711 47.2637 4.44714 47.2637 4.66183V6.8854H48.8549C49.0912 6.8854 49.2803 7.06942 49.2803 7.29944V9.38499C49.296 9.61502 49.107 9.79904 48.8706 9.79904Z'
      fill='#8246AF'
    />
    <path
      d='M55.6766 18.9847C52.1633 18.9847 50.1467 17.0371 50.1467 13.4488V12.268C50.1467 8.66425 52.1633 6.73205 55.6766 6.73205C59.1899 6.73205 61.175 8.67959 61.175 12.268V13.4488C61.1907 17.0371 59.1899 18.9847 55.6766 18.9847ZM57.1733 12.2526C57.1733 10.6425 56.6534 9.99839 55.6766 9.99839C54.7156 9.99839 54.1642 10.6118 54.1642 12.2526V13.4334C54.1642 15.0436 54.7156 15.703 55.6766 15.703C56.6376 15.703 57.1733 15.0743 57.1733 13.4334V12.2526Z'
      fill='#8246AF'
    />
    <path
      d='M72.8176 18.8007H69.903C69.6667 18.8007 69.4776 18.6166 69.4776 18.3866V17.9112C68.7214 18.4633 67.7131 18.9693 66.1534 18.9693C63.0498 18.9693 62.2935 16.6998 62.2935 14.2615V7.34544C62.2935 7.11542 62.4668 6.90073 62.7189 6.90073H65.8698C66.1219 6.90073 66.3267 7.13075 66.3267 7.34544V14.2768C66.3267 15.3656 66.5788 15.7337 67.6343 15.7337C68.1227 15.7337 68.7214 15.5343 69.2098 15.289V7.34544C69.2098 7.11542 69.3831 6.90073 69.6352 6.90073H72.7861C73.0381 6.90073 73.243 7.13075 73.243 7.34544V18.3866C73.243 18.6166 73.0539 18.8007 72.8176 18.8007Z'
      fill='#8246AF'
    />
    <path
      d='M82.3491 18.6626C81.6401 18.8313 80.7106 18.9847 79.466 18.9847C76.2521 18.9847 74.4403 16.9758 74.4403 13.6328V12.0993C74.4403 8.7716 76.2521 6.71672 79.466 6.71672C80.7106 6.71672 81.7504 6.90074 82.3491 7.03875C82.6169 7.10009 82.7745 7.20744 82.7745 7.46813V9.78371C82.7745 10.0291 82.6484 10.2131 82.3333 10.1671C81.6244 10.1057 80.9469 10.0291 79.9229 10.0291C79.0249 10.0291 78.4892 10.5811 78.4892 12.0993V13.6328C78.4892 15.1509 79.0091 15.6723 79.9229 15.6723C80.9469 15.6723 81.6244 15.6263 82.3333 15.5497C82.6484 15.5036 82.7745 15.6723 82.7745 15.933V18.2179C82.7745 18.494 82.6169 18.6013 82.3491 18.6626Z'
      fill='#8246AF'
    />
    <path
      d='M94.5589 18.8006H91.3764C91.1401 18.8006 90.9511 18.6166 90.9511 18.3866V11.3325C90.9511 10.2437 90.4942 9.98305 89.6277 9.98305C89.1393 9.98305 88.5721 10.1517 88.0365 10.4278V18.3406C88.0365 18.5706 87.8632 18.7853 87.6111 18.7853H84.4602C84.2081 18.7853 84.0033 18.5553 84.0033 18.3406V3.40436C84.0033 3.17434 84.1924 2.99032 84.4287 2.99032H87.6269C87.8632 2.99032 88.0522 3.17434 88.0522 3.40436V7.51413C88.9502 6.90073 89.8798 6.73204 91.1559 6.73204C94.1808 6.73204 95 8.80226 95 11.3325V18.3866C94.9842 18.6166 94.7952 18.8006 94.5589 18.8006Z'
      fill='#8246AF'
    />
    <path
      d='M25.3963 4.53915L24.6244 1.61017C24.388 0.705408 23.3797 0 22.3872 0H16.1169L11.4063 18.9847H15.5812C16.2114 18.9847 16.8416 18.5246 16.9676 17.9572L17.6136 15.3196H22.7181L25.3963 4.53915ZM18.6376 11.2865L19.9925 5.84262H20.4336L21.757 11.2865H18.6376Z'
      fill='#8246AF'
    />
    <path
      d='M37.9212 8.52623C39.0398 7.71348 39.7173 6.37934 39.7173 4.99919C39.7173 1.82485 37.4801 0.0153309 33.573 0.0153309H27.6335L25.0497 10.4584V17.0218C25.0497 18.0492 25.2861 19 27.0506 19H33.7463C37.6692 19 40.5207 16.5157 40.5207 13.0807C40.5207 11.0565 39.5597 9.36965 37.9212 8.52623ZM29.9022 4.23244H33.2736C34.2189 4.23244 34.7546 4.69249 34.7546 5.50524C34.7546 6.44068 34.2189 6.91606 33.1476 6.91606H29.9179V4.23244H29.9022ZM33.3524 14.7369H29.9022V10.8571H33.3524C34.7231 10.8571 35.5423 11.5932 35.5423 12.8047C35.5423 13.2647 35.3847 14.7369 33.3524 14.7369Z'
      fill='#8246AF'
    />
    <path
      d='M10.2877 18.9847L11.1227 15.6263V4.56982H13.864L14.9983 0H1.00829C0.299337 0 0 0.276029 0 0.920097V3.64972C0 4.23245 0.362355 4.55448 1.00829 4.55448H5.67164V18.0339C5.67164 18.6473 6.06551 18.9693 6.79022 18.9693H10.2877V18.9847Z'
      fill='#8246AF'
    />
  </svg>
)

export const AppleAppStore = () => (
  <svg viewBox='0 0 135 40'>
    <g>
      <path
        d='M134 35.3a3.8 3.8 0 0 1-3.8 3.8H4.8A3.8 3.8 0 0 1 1 35.3V4.8A3.8 3.8 0 0 1 4.8 1h125.4a3.8 3.8 0 0 1 3.8 3.8v30.5Z'
        fill='#fff'
      />
      <path
        fill='#a6a6a6'
        d='M130.2 40H4.8A4.7 4.7 0 0 1 0 35.3V4.8A4.7 4.7 0 0 1 4.7 0H130a4.7 4.7 0 0 1 4.7 4.7v30.5a4.6 4.6 0 0 1-4.6 4.8Z'
      />
      <path d='M134 35.3a3.8 3.8 0 0 1-3.8 3.8H4.8A3.8 3.8 0 0 1 1 35.3V4.8A3.8 3.8 0 0 1 4.8 1h125.4a3.8 3.8 0 0 1 3.8 3.8v30.5Z' />
      <path
        d='M30 19.8a5.9 5.9 0 0 1 2.9-4.9c-3.1-4.1-6.7-2.2-9.6-1.4-1 0-2.6-1.2-4.2-1.1a6.2 6.2 0 0 0-5.2 3.2c-2.8 4.8.4 14.9 5.6 16.1 1.6-.1 2.2-1 4.2-1s2.5 1 4.2 1c2.5.4 5.5-5.7 5.7-6.7a6 6 0 0 1-3.5-5.2Zm-3-9.5a5.5 5.5 0 0 0 1.3-4.1 5.6 5.6 0 0 0-5.1 5.9 4.7 4.7 0 0 0 3.8-1.8Zm26.7 21.2h-2.3l-1.2-3.9h-4.3l-1.2 3.9h-2.2l4.3-13.3h2.6l4.3 13.3Zm-4-5.6-1.7-6c-.2 1.2-1.3 4.6-1.7 6Zm14.9.7c.4 4-4.5 7.1-7 3.8v5h-2.1l-.1-13.5h1.9v1.5c2.5-3.6 7.7-1 7.3 3.2Zm-2.1.1c-.2-5.1-5.7-3.9-5 .9.3 3.9 5.4 2.8 5-.9Zm13.2-.1c.4 4-4.5 7.1-7 3.8v5h-2.1l-.1-13.5h1.9v1.5c2.5-3.6 7.7-1 7.3 3.2Zm-2.2.1c-.2-5.1-5.7-3.9-5 .9.3 3.9 5.5 2.8 5-.9ZM88 27.8c.2 4.1-5.6 4.8-8.3 3.1l.5-1.8c3.9 2.6 8.7-1.3 3.2-3.6-7.5-3-1.6-9.8 4-6.9l-.4 1.8c-1.9-1.4-6.6-.4-4.2 2.4 1.8 1.3 5.5 2 5.2 5Zm7.1-4.3h-2.3v4.7c-.1 1.7 1 2 2.2 1.7l.1 1.6c-5.6 1.7-4.2-4.6-4.3-8h-1.4v-1.6h1.4v-1.8l2.1-.6v2.4h2.3l-.1 1.6Zm10.6 3.1c.2 6.6-9.5 6.8-9.4.2-.3-6.6 9.5-6.9 9.4-.2Zm-2.2.1c.1-4.5-5.2-4.5-5 0-.2 4.5 5.1 4.5 5 0Zm9.1-2.9c-4.2-.9-2.7 5.5-2.9 7.7h-2.1l-.1-9.6h1.9l.1 1.8h.1a2.8 2.8 0 0 1 3.1-2l-.1 2.1Zm9.5 2.4a3.8 3.8 0 0 1 0 1h-6.5c-.1 3 3.5 3.3 5.6 2.4l.3 1.5c-5.8 2.5-10.4-2.6-6.8-7.9a4.2 4.2 0 0 1 7.4 3Zm-2-.5c.2-3.4-4.3-3.2-4.4 0ZM45.2 13.5a6.6 6.6 0 0 1-1.5-.1V7c2.5-.5 5.6.3 5.4 3-.1 2.3-1.4 3.5-4 3.5Zm.4-5.8a2 2 0 0 0-.8.1v4.9c3.5.8 4.6-5 .8-5Zm6.9 5.8c-3 .1-3-5.1 0-4.9 3.2-.1 3 5.1 0 4.9Zm0-4.1c-1.5-.1-1.5 3.5 0 3.4s1.7-3.5 0-3.4Zm10.3-.7-1.5 4.7h-1l-1-3.6a24.2 24.2 0 0 1-1 3.6h-1l-1.4-4.7H57l.9 3.8A31.8 31.8 0 0 1 59 8.7h.9l1 3.8c.1-.9.7-2.8.9-3.8Zm5.4 4.7h-1c-.2-.9.6-4.1-1-4s-1 3-1 4h-1V8.7h.8v.7a1.7 1.7 0 0 1 3.1 1.2 26.2 26.2 0 0 1 .1 2.8Zm2.9 0h-1V6.6h1Zm3.8.1c-3 .1-3-5.1 0-4.9 3.1-.1 3 5.1 0 4.9Zm0-4.1c-1.6-.1-1.6 3.5 0 3.4s1.6-3.5 0-3.4Zm6.5 4-.1-.5c-3 2.5-4.5-2.8-.1-2.5.1-1.3-1.5-1.2-2.2-.7l-.2-.7c4.1-1.6 3.4 1.7 3.5 4.4Zm-.2-2.3c-1.7-.3-2.4 1.4-1 1.7.9 0 1.1-1 1-1.7Zm6.1 2.3v-.8c-1 1.8-3.6.6-3.5-1.5-.2-2.1 2.2-3.4 3.4-1.9V6.6h1v6.9c.1-.1-.9-.1-.9-.1Zm-.1-2.7a1 1 0 0 0-1.1-1.2c-1.6-.1-1.7 3.4 0 3.3 1-.1 1.2-1.3 1.1-2.1Zm7.7 2.8c-3 .1-3-5.1.1-4.9 3-.1 2.9 5.1-.1 4.9Zm0-4.1c-1.6-.1-1.6 3.5 0 3.4s1.6-3.5 0-3.4Zm8 4h-1c-.2-.9.6-4.1-1-4s-.9 3-1 4h-1V8.7h.9v.7a1.7 1.7 0 0 1 3.1 1.2Zm7-3.9h-1.2c.1.8-.6 3.7 1.1 3.1v.8c-2.6.9-2.1-2.2-2.1-3.9h-.7v-.8h.7v-.8l1-.3v1.2h1.2v.7Zm5.6 3.9h-1c-.2-.9.6-4.1-1-4-1.6-.1-.9 3.1-1 4h-1V6.6h1v2.8a1.6 1.6 0 0 1 3 1.2v2.8Zm5.6-2.1H118c0 1.5 1.7 1.6 2.8 1.2l.2.7c-4 1.8-5.6-4.1-1.7-4.6a2 2 0 0 1 1.8 2.7Zm-.9-.7c.1-1.7-2-1.6-2.2 0Z'
        fill='#fff'
      />
    </g>
  </svg>
)

export const GooglePlayStore = () => (
  <svg viewBox='0 0 135 40'>
    <defs>
      <linearGradient
        id='a'
        x1='21.7'
        x2='5'
        y1='926.6'
        y2='943.3'
        gradientTransform='translate(0 -918)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#00a0ff' />
        <stop offset='0' stopColor='#00a1ff' />
        <stop offset='.3' stopColor='#00beff' />
        <stop offset='.5' stopColor='#00d2ff' />
        <stop offset='.8' stopColor='#00dfff' />
        <stop offset='1' stopColor='#00e3ff' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='33.7'
        x2='9.6'
        y1='937.9'
        y2='937.9'
        gradientTransform='translate(0 -918)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#ffe000' />
        <stop offset='.4' stopColor='#ffbd00' />
        <stop offset='.8' stopColor='orange' />
        <stop offset='1' stopColor='#ff9c00' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='24.8'
        x2='2'
        y1='940.2'
        y2='962.9'
        gradientTransform='translate(0 -918)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#ff3a44' />
        <stop offset='1' stopColor='#c31162' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='7.3'
        x2='17.4'
        y1='918.1'
        y2='928.2'
        gradientTransform='translate(0 -918)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset='0' stopColor='#32a071' />
        <stop offset='.1' stopColor='#2da771' />
        <stop offset='.5' stopColor='#15cf74' />
        <stop offset='.8' stopColor='#06e775' />
        <stop offset='1' stopColor='#00f076' />
      </linearGradient>
    </defs>
    <g>
      <path d='M129.5 39.9H5a5 5 0 0 1-5-5V5a5 5 0 0 1 5-5h124.5a5 5 0 0 1 5 5v29.9a5 5 0 0 1-5 5Z' />
      <path
        fill='#a6a6a6'
        d='M129.5.8a4.2 4.2 0 0 1 4.2 4.2v29.9a4.2 4.2 0 0 1-4.2 4.1H5a4.2 4.2 0 0 1-4.2-4.1V5A4.2 4.2 0 0 1 5 .8h124.5m0-.8H5a5 5 0 0 0-5 5v29.9a5 5 0 0 0 5 5h124.5a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5Z'
      />
      <path
        fill='#fff'
        stroke='#fff'
        strokeMiterlimit='10'
        strokeWidth='.2'
        d='M47.3 10.2c.1 2.7-3.4 3.8-5.2 2-2.9-2.9 1.5-7.3 4.4-4.4l-.6.5c-2-2.3-5.5 1.3-3.2 3.4 1.2 1.3 3.7.7 3.8-1.2h-2.2v-.8h2.9a1.6 1.6 0 0 1 0 .5Zm4.5-2.5h-2.7v1.9h2.5v.7H49v2h2.7v.7h-3.5V7h3.5ZM55 13h-.7V7.7h-1.7V7h4.1v.7h-1.6V13Zm4.7 0V7h.8v6Zm4.3 0h-1V7.7h-1.6V7h4v.7H64V13Zm9.3-.8c-2.9 2.9-7.2-1.6-4.3-4.4s7.2 1.5 4.3 4.4Zm-3.8-.5c2.2 2.2 5.4-1.4 3.3-3.4s-5.4 1.3-3.3 3.4Zm5.8 1.3V7h1l2.8 4.7V7h.8v6h-.8l-3-5v5Z'
      />
      <path
        fill='#fff'
        d='M67.9 21.6c-5.6 0-5.6 8.5 0 8.5s5.6-8.4 0-8.5Zm0 6.9c-3.1 0-3.1-5.2 0-5.2s3.1 5.2 0 5.2Zm-9.3-6.9c-5.6 0-5.6 8.5 0 8.5s5.6-8.4 0-8.5Zm0 6.9c-3.1 0-3.1-5.2 0-5.2s3.1 5.2 0 5.2Zm-11-5.5v1.8h4.3c-.6 5.5-9.3 4.2-9-1.2-.3-4.1 5.2-6.3 8-3.5l1.2-1.3c-3.6-4-11.4-.8-11.1 4.8.1 9 14.2 8.6 12.7-.6Zm45.1 1.4a4 4 0 0 0-7.6 1.6c-.1 4.3 5.9 5.5 7.7 2.3l-1.4-1a2.4 2.4 0 0 1-4.2-.1l5.7-2.4ZM87 25.8c0-2.4 3-3.3 3.8-1.6ZM82.3 30h1.9V17.4h-1.9Zm-3-7.2c-2.2-2.4-6.5 0-6.3 3.2-.2 3.3 4.1 5.7 6.3 3.3.6 3.2-3.2 4.2-4.4 1.6l-1.6.7c1.4 3.7 8 3.4 7.8-2V22h-1.8Zm-2.1 5.8c-3.1 0-3-5.2 0-5.1 2.9-.2 3 5.2 0 5Zm24.3-11H97V30h1.9v-5h2.5a3.9 3.9 0 1 0 0-7.7Zm0 6h-2.7v-4.4h2.7a2.1 2.1 0 1 1 0 4.3Zm11.5-1.9a3.5 3.5 0 0 0-3.3 2l1.6.6c.8-1.5 3.8-1 3.7.9-1.8-1.1-5.6-.3-5.5 2.3-.2 2.8 4.3 3.7 5.4 1.5h.1v1h1.8c-.2-3.2 1-8.3-3.8-8.3Zm-.2 6.9c-3.4-.5-.4-3.6 2.2-2a2.2 2.2 0 0 1-2.3 2Zm10.5-6.6-2.1 5.4h-.1l-2.2-5.4h-2l3.3 7.6-1.9 4.2h2l5.1-11.8Zm-16.8 8h1.9V17.4h-1.9Z'
      />
      <path
        fill='url(#a)'
        d='M10.4 7.5c-1.1 0-.1 22.7-.5 23.4a2 2 0 0 0 .6 1.5l12.3-12.3v-.4L10.5 7.4Z'
      />
      <path fill='url(#b)' d='M27 24.2 22.7 20v-.4l4.2-4c8 4.4 8 4 0 8.5Z' />
      <path fill='url(#c)' d='M27 24.1 22.8 20 10.4 32.4c.8 2 15.5-8.1 16.6-8.3' />
      <path fill='url(#d)' d='M27 15.7 12.5 7.4a1.7 1.7 0 0 0-2.1 0L22.8 20Z' />
      <path d='M27 24c-1.3.2-15.5 10-16.5 8.2l-.1.1c1 1.9 15.5-8 16.6-8.2Z' opacity='.2' />
      <path
        d='M10.4 32.2a2 2 0 0 1-.5-1.4 2.3 2.3 0 0 0 .5 1.5Zm21.6-11L27 24v.1c1-.7 6-2.7 6-4.2a2 2 0 0 1-1 1.3Z'
        opacity='.1'
      />
      <path
        fill='#fff'
        d='M12.5 7.6c.6.6 21.1 11.2 20.5 12.3 1-1.1-20-11.8-20.5-12.5-1.5-.8-2.7 0-2.5 1.7 0-1.6 1-2.3 2.5-1.5Z'
        opacity='.3'
      />
    </g>
  </svg>
)
